import { DefaultEditor } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';

@Component({
  template: `
  <div>
    <angular2-multiselect class="type-selector" #selecTipoAtributo [data]=typesAttr [(ngModel)]="selectedTypeAttr"
        (onSelect)="changeTypeAttr($event)"
        [settings]="dropdownSettings"></angular2-multiselect>
  </div>
  `,
})

export class AttributeTypeCellComponent extends DefaultEditor implements OnInit {
  typesAttr = [
    { item_id: 'text', item_text: 'Texto' },
    { item_id: 'number', item_text: 'Número' },
    { item_id: 'date', item_text: 'Fecha' },
  ];
  selectedTypeAttr = [];
  dropdownSettings = {
    singleSelection: true,
    labelKey:"item_text",
    primaryKey:"item_id",
    text:"Seleccione un tipo",
    autoPosition:false
  };

  async ngOnInit() {
    this.selectedTypeAttr = [];
    if(this.cell.newValue){
      this.selectedTypeAttr.push(this.typesAttr.find( t => t.item_id == this.cell.newValue) );
    }
  };

  changeTypeAttr(evento){
    this.cell.newValue = this.selectedTypeAttr[0].item_id;
  }
}
